// Imports
import axios from "axios";
import "../../../setup/config/apiConfig";

export const RESET = "RESET";
export const GET_ACCOUNT_DISCONNECTS = "GET_ACCOUNT_DISCONNECTS";
export const GET_ACCOUNT_DISCONNECTS_RESPONSE =
  "GET_ACCOUNT_DISCONNECTS_RESPONSE";
export const GET_ACCOUNT_DISCONNECTS_FAIL = "GET_ACCOUNT_DISCONNECTS_FAIL";

export const GET_ACCOUNT_DISCONNECT = "GET_ACCOUNT_DISCONNECT";
export const GET_ACCOUNT_DISCONNECT_RESPONSE =
  "GET_ACCOUNT_DISCONNECT_RESPONSE";
export const GET_ACCOUNT_DISCONNECT_FAIL = "GET_ACCOUNT_DISCONNECT_FAIL";

export const POST_ACCOUNT_DISCONNECT = "POST_ACCOUNT_DISCONNECT";
export const POST_ACCOUNT_DISCONNECT_RESPONSE =
  "POST_ACCOUNT_DISCONNECT_RESPONSE";
export const POST_ACCOUNT_DISCONNECT_FAIL = "POST_ACCOUNT_DISCONNECT_FAIL";

export const PUT_ACCOUNT_DISCONNECT = "PUT_ACCOUNT_DISCONNECT";
export const PUT_ACCOUNT_DISCONNECT_RESPONSE =
  "PUT_ACCOUNT_DISCONNECT_RESPONSE";
export const PUT_ACCOUNT_DISCONNECT_FAIL = "PUT_ACCOUNT_DISCONNECT_FAIL";

export const PROCESS_ACCOUNT_DISCONNECTS = "PROCESS_ACCOUNT_DISCONNECTS";
export const PROCESS_ACCOUNT_DISCONNECTS_RESPONSE =
  "PROCESS_ACCOUNT_DISCONNECTS_RESPONSE";
export const PROCESS_ACCOUNT_DISCONNECTS_FAIL =
  "PROCESS_ACCOUNT_DISCONNECTS_FAIL";

export const DELETE_ACCOUNT_DISCONNECTS_REQUEST =
  "DELETE_ACCOUNT_DISCONNECTS_REQUEST";
export const DELETE_ACCOUNT_DISCONNECTS_RESPONSE =
  "DELETE_ACCOUNT_DISCONNECTS_RESPONSE";
export const DELETE_ACCOUNT_DISCONNECTS_FAIL =
  "DELETE_ACCOUNT_DISCONNECTS_FAIL";

export const GET_WEEKLY_ACCOUNT_DISCONNECTS = "GET_WEEKLY_ACCOUNT_DISCONNECTS";
export const GET_WEEKLY_ACCOUNT_DISCONNECTS_RESPONSE =
  "GET_WEEKLY_ACCOUNT_DISCONNECTS_RESPONSE";
export const GET_WEEKLY_ACCOUNT_DISCONNECTS_FAIL =
  "GET_WEEKLY_ACCOUNT_DISCONNECTS_FAIL";

export const GET_DISCONNECT_METRICS_REQUEST = "GET_DISCONNECT_METRICS_REQUEST";
export const GET_DISCONNECT_METRICS_RESPONSE = "GET_DISCONNECT_METRICS_RESPONSE";
export const GET_DISCONNECT_METRICS_FAIL = "GET_DISCONNECT_METRICS_FAIL";

export const GET_ACCOUNT_DISCONNECTS_FOR_QUEUE = "GET_ACCOUNT_DISCONNECTS_FOR_QUEUE";
export const GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_RESPONSE = "GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_RESPONSE";
export const GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_FAIL = "GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_FAIL";

export const GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID = "GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID";
export const GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_RESPONSE = "GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_RESPONSE";
export const GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_FAIL = "GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_FAIL";

export const REVERT_ACCOUNT_DISCONNECT = "REVERT_ACCOUNT_DISCONNECT";
export const REVERT_ACCOUNT_DISCONNECT_RESPONSE = "REVERT_ACCOUNT_DISCONNECT_RESPONSE";
export const REVERT_ACCOUNT_DISCONNECT_FAIL = "REVERT_ACCOUNT_DISCONNECT_FAIL";

export const RESCHEDULE_ACCOUNT_DISCONNECT = "RESCHEDULE_ACCOUNT_DISCONNECT";
export const RESCHEDULE_ACCOUNT_DISCONNECT_RESPONSE = "RESCHEDULE_ACCOUNT_DISCONNECT_RESPONSE";
export const RESCHEDULE_ACCOUNT_DISCONNECT_FAIL = "RESCHEDULE_ACCOUNT_DISCONNECT_FAIL";

export function get(
  page,
  pageLimit,
  type,
  searchQuery,
  isLoading = true,
  isReset = false,
  propertyUuid,
  disconnectStatusQueryType,
  disconnectAccountQueryType
) {
  return (dispatch) => {
    dispatch({
      type: GET_ACCOUNT_DISCONNECTS,
      isLoading: isLoading,
      isReset: isReset,
    });
    let queryParams = {
      page: page,
      pageLimit: pageLimit,
      type: type,
      searchQuery: searchQuery,
      propertyUuid: propertyUuid,
      accountStatus: disconnectStatusQueryType,
      accountType: disconnectAccountQueryType
    };
    if (propertyUuid == "") {
      delete queryParams.propertyUuid
    }
    return axios
      .get("/accountDisconnects", { params: queryParams })
      .then((res) => {
        var accountDisconnects = res.data;

        dispatch({
          type: GET_ACCOUNT_DISCONNECTS_RESPONSE,
          accountDisconnects: accountDisconnects,
          isReset: isReset,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ACCOUNT_DISCONNECTS_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function getByUuid(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_ACCOUNT_DISCONNECT,
      isLoading: isLoading,
    });
    return axios
      .get(`/accountDisconnect/${uuid}`, {})
      .then((response) => {
        dispatch({
          type: GET_ACCOUNT_DISCONNECT_RESPONSE,
          accountDisconnect: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_ACCOUNT_DISCONNECT_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}

export function deleteByUuid(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: DELETE_ACCOUNT_DISCONNECTS_REQUEST,
      isLoading: isLoading,
    });
    return axios
      .delete(`/accountDisconnect/` + uuid)
      .then((response) => {
        dispatch({
          type: DELETE_ACCOUNT_DISCONNECTS_RESPONSE,
        });
      })
      .catch((error) => {
        dispatch({
          type: DELETE_ACCOUNT_DISCONNECTS_FAIL,
          isLoading: false,
        });
      });
  };
}

export function put(accountDisconnect, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: PUT_ACCOUNT_DISCONNECT,
      isLoading,
    });
    return axios
      .put("/accountDisconnect/" + accountDisconnect.uuid, accountDisconnect)
      .then((response) => {
        dispatch({
          accountDisconnect: response.data,
          type: PUT_ACCOUNT_DISCONNECT_RESPONSE,
        });
      })
      .catch((error) => {
        //console.log(error);
        dispatch({
          type: PUT_ACCOUNT_DISCONNECT_FAIL,
          error: error,
        });
      });
  };
}

export function post(accountDisconnect, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: POST_ACCOUNT_DISCONNECT,
      isLoading,
    });
    return axios.post("/accountdisconnects/custom", accountDisconnect).then((response) => {
      dispatch({
        accountDisconnect: response.data,
        type: POST_ACCOUNT_DISCONNECT_RESPONSE,
      });
      return response.data;
    })
      .catch((error) => {
        dispatch({
          type: POST_ACCOUNT_DISCONNECT_FAIL,
          error: error,
        });
        throw error;
      });
  };
}

export function processDisconnects(
  uuids,
  disconnectDate,
  callType,
  isLoading = false
) {
  return (dispatch) => {
    dispatch({
      type: POST_ACCOUNT_DISCONNECT,
      isLoading,
    });
    return axios
      .post("/accountdisconnects/pending", {
        uuids: uuids,
        disconnectDate: disconnectDate,
        type: callType,
      })
      .then((response) => {
        dispatch({
          res: response.data,
          type: POST_ACCOUNT_DISCONNECT_RESPONSE,
        });
      })
      .catch((error) => {
        //console.log(error);
        dispatch({
          type: POST_ACCOUNT_DISCONNECT_FAIL,
          error: error,
        });
      });
  };
}

export function getWeekly(weekStartDate, status, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_WEEKLY_ACCOUNT_DISCONNECTS,
      isLoading: isLoading,
    });

    const queryParams = {
      weekStartDate: weekStartDate,
      status: status,
    };

    return axios
      .get("/accountdisconnects-weekly", { params: queryParams })
      .then((res) => {
        dispatch({
          type: GET_WEEKLY_ACCOUNT_DISCONNECTS_RESPONSE,
          weeklyData: res.data,
          isLoading: false,
          error: null,
        });
        return res.data;
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.ERROR || 
                            error?.response?.data?.message || 
                            error?.message || 
                            'Failed to fetch weekly disconnect data';
        dispatch({
          type: GET_WEEKLY_ACCOUNT_DISCONNECTS_FAIL,
          isLoading: false,
          error: errorMessage,
        });
        throw error;
      });
  };
}

export function getDisconnectMetrics(isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_DISCONNECT_METRICS_REQUEST,
      isLoading: isLoading,
    });

    return axios
      .get("/disconnect-metrics")
      .then((response) => {
        dispatch({
          type: GET_DISCONNECT_METRICS_RESPONSE,
          metricsData: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_DISCONNECT_METRICS_FAIL,
          isLoading: false,
          error: error.message || 'Failed to fetch disconnect metrics',
        });
        throw error;
      });
  };
}

export function getAccountDisconnectsForQueue(params = {}, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_ACCOUNT_DISCONNECTS_FOR_QUEUE,
      isLoading: isLoading,
    });

    return axios
      .get("/accountdisconnects-for-queue", { params })
      .then((response) => {
        dispatch({
          type: GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_RESPONSE,
          queueData: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_ACCOUNT_DISCONNECTS_FOR_QUEUE_FAIL,
          isLoading: false,
          error: error.message || 'Failed to fetch disconnect queue',
        });
        throw error;
      });
  };
}

export function getAccountDisconnectForQueueByUuid(uuid, isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID,
      isLoading: isLoading,
    });

    return axios
      .get(`/accountdisconnects-for-queue/${uuid}`)
      .then((response) => {
        dispatch({
          type: GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_RESPONSE,
          queueItem: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: GET_ACCOUNT_DISCONNECT_FOR_QUEUE_BY_UUID_FAIL,
          isLoading: false,
          error: error.message || 'Failed to fetch disconnect from queue',
        });
        throw error;
      });
  };
}


export function revertAccountDisconnect(uuid, newStatus, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: REVERT_ACCOUNT_DISCONNECT,
      isLoading: isLoading,
    });

    return axios
      .post(`/accountdisconnect-revert/${uuid}?newStatus=${newStatus}`)
      .then((response) => {
        dispatch({
          type: REVERT_ACCOUNT_DISCONNECT_RESPONSE,
          data: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: REVERT_ACCOUNT_DISCONNECT_FAIL,
          isLoading: false,
          error: error.response?.data?.ERROR || error.response?.data?.message || error.message || 'Failed to revert disconnect',
        });
        throw error;
      });
  };
}


export function rescheduleAccountDisconnect(disconnectUuid, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: RESCHEDULE_ACCOUNT_DISCONNECT,
      isLoading: isLoading,
    });

    // Format current date as YYYY-MM-DD HH:mm:ss (MySQL DATETIME format)
    const currentDate = new Date().toISOString().slice(0, 19).replace('T', ' ');

    const updateData = {
      uuid: disconnectUuid,
      manualHold: currentDate,
    };

    return axios
      .put(`/accountDisconnect/${disconnectUuid}`, updateData)
      .then((response) => {
        dispatch({
          type: RESCHEDULE_ACCOUNT_DISCONNECT_RESPONSE,
          data: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: RESCHEDULE_ACCOUNT_DISCONNECT_FAIL,
          isLoading: false,
          error: error.response?.data?.ERROR || error.response?.data?.message || error.message || 'Failed to reschedule disconnect',
        });
        throw error;
      });
  };
}

export const MARK_DISCONNECT_AS_PENDING = "MARK_DISCONNECT_AS_PENDING";
export const MARK_DISCONNECT_AS_PENDING_RESPONSE = "MARK_DISCONNECT_AS_PENDING_RESPONSE";
export const MARK_DISCONNECT_AS_PENDING_FAIL = "MARK_DISCONNECT_AS_PENDING_FAIL";

export function markDisconnectAsPending(disconnectUuid, disconnectDate = null, isLoading = false, pendingType = '') {
  return (dispatch) => {
    dispatch({
      type: MARK_DISCONNECT_AS_PENDING,
      isLoading: isLoading,
    });

    const requestData = {
      uuids: [disconnectUuid],
      type: pendingType,
    };

    if (disconnectDate) {
      requestData.disconnectDate = disconnectDate;
    }

    return axios
      .post("/accountdisconnects/pending", requestData)
      .then((response) => {
        dispatch({
          type: MARK_DISCONNECT_AS_PENDING_RESPONSE,
          data: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: MARK_DISCONNECT_AS_PENDING_FAIL,
          isLoading: false,
          error: error.response?.data?.ERROR || error.response?.data?.message || error.message || 'Failed to mark disconnect as pending',
        });
        throw error;
      });
  };
}

export const RESEND_DISCONNECT_NOTICE = "RESEND_DISCONNECT_NOTICE";
export const RESEND_DISCONNECT_NOTICE_RESPONSE = "RESEND_DISCONNECT_NOTICE_RESPONSE";
export const RESEND_DISCONNECT_NOTICE_FAIL = "RESEND_DISCONNECT_NOTICE_FAIL";

export function resendDisconnectNotice(disconnectUuid, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: RESEND_DISCONNECT_NOTICE,
      isLoading: isLoading,
    });

    return axios
      .post(`/accountdisconnect/${disconnectUuid}/resend-notice`)
      .then((response) => {
        dispatch({
          type: RESEND_DISCONNECT_NOTICE_RESPONSE,
          data: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: RESEND_DISCONNECT_NOTICE_FAIL,
          isLoading: false,
          error: error.response?.data?.ERROR || error.response?.data?.message || error.message || 'Failed to resend disconnect notice',
        });
        throw error;
      });
  };
}

export const REVERT_ACCOUNT_DISCONNECTS_BULK = "REVERT_ACCOUNT_DISCONNECTS_BULK";
export const REVERT_ACCOUNT_DISCONNECTS_BULK_RESPONSE = "REVERT_ACCOUNT_DISCONNECTS_BULK_RESPONSE";
export const REVERT_ACCOUNT_DISCONNECTS_BULK_FAIL = "REVERT_ACCOUNT_DISCONNECTS_BULK_FAIL";

export function revertAccountDisconnectsBulk(disconnectUuids, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: REVERT_ACCOUNT_DISCONNECTS_BULK,
      isLoading: isLoading,
    });

    return axios
      .post("/accountdisconnect-revert-bulk", {
        disconnectUuids: disconnectUuids,
      })
      .then((response) => {
        dispatch({
          type: REVERT_ACCOUNT_DISCONNECTS_BULK_RESPONSE,
          data: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: REVERT_ACCOUNT_DISCONNECTS_BULK_FAIL,
          isLoading: false,
          error: error.response?.data?.ERROR || error.response?.data?.message || error.message || 'Failed to revert disconnects',
        });
        throw error;
      });
  };
}

export const MARK_DISCONNECTS_AS_PENDING_BULK = "MARK_DISCONNECTS_AS_PENDING_BULK";
export const MARK_DISCONNECTS_AS_PENDING_BULK_RESPONSE = "MARK_DISCONNECTS_AS_PENDING_BULK_RESPONSE";
export const MARK_DISCONNECTS_AS_PENDING_BULK_FAIL = "MARK_DISCONNECTS_AS_PENDING_BULK_FAIL";

export function markDisconnectsAsPendingBulk(disconnectUuids, isLoading = false, pendingType = '') {
  return (dispatch) => {
    dispatch({
      type: MARK_DISCONNECTS_AS_PENDING_BULK,
      isLoading: isLoading,
    });

    const requestData = {
      uuids: disconnectUuids,
      type: pendingType,
    };

    return axios
      .post("/accountdisconnects/pending", requestData)
      .then((response) => {
        dispatch({
          type: MARK_DISCONNECTS_AS_PENDING_BULK_RESPONSE,
          data: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: MARK_DISCONNECTS_AS_PENDING_BULK_FAIL,
          isLoading: false,
          error: error.response?.data?.ERROR || error.response?.data?.message || error.message || 'Failed to mark disconnects as pending',
        });
        throw error;
      });
  };
}

export const RESCHEDULE_ACCOUNT_DISCONNECTS_BULK = "RESCHEDULE_ACCOUNT_DISCONNECTS_BULK";
export const RESCHEDULE_ACCOUNT_DISCONNECTS_BULK_RESPONSE = "RESCHEDULE_ACCOUNT_DISCONNECTS_BULK_RESPONSE";
export const RESCHEDULE_ACCOUNT_DISCONNECTS_BULK_FAIL = "RESCHEDULE_ACCOUNT_DISCONNECTS_BULK_FAIL";

export function rescheduleAccountDisconnectsBulk(disconnectUuids, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: RESCHEDULE_ACCOUNT_DISCONNECTS_BULK,
      isLoading: isLoading,
    });

    return axios
      .post("/accountdisconnect-reschedule-bulk", {
        disconnectUuids: disconnectUuids,
      })
      .then((response) => {
        dispatch({
          type: RESCHEDULE_ACCOUNT_DISCONNECTS_BULK_RESPONSE,
          data: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: RESCHEDULE_ACCOUNT_DISCONNECTS_BULK_FAIL,
          isLoading: false,
          error: error.response?.data?.ERROR || error.response?.data?.message || error.message || 'Failed to reschedule disconnects',
        });
        throw error;
      });
  };
}

export const RESEND_DISCONNECT_NOTICES_BULK = "RESEND_DISCONNECT_NOTICES_BULK";
export const RESEND_DISCONNECT_NOTICES_BULK_RESPONSE = "RESEND_DISCONNECT_NOTICES_BULK_RESPONSE";
export const RESEND_DISCONNECT_NOTICES_BULK_FAIL = "RESEND_DISCONNECT_NOTICES_BULK_FAIL";

export function resendDisconnectNoticesBulk(disconnectUuids, isLoading = false) {
  return (dispatch) => {
    dispatch({
      type: RESEND_DISCONNECT_NOTICES_BULK,
      isLoading: isLoading,
    });

    return axios
      .post("/accountdisconnect-resend-notice-bulk", {
        disconnectUuids: disconnectUuids,
      })
      .then((response) => {
        dispatch({
          type: RESEND_DISCONNECT_NOTICES_BULK_RESPONSE,
          data: response.data,
          isLoading: false,
          error: null,
        });
        return response.data;
      })
      .catch((error) => {
        dispatch({
          type: RESEND_DISCONNECT_NOTICES_BULK_FAIL,
          isLoading: false,
          error: error.response?.data?.ERROR || error.response?.data?.message || error.message || 'Failed to resend disconnect notices',
        });
        throw error;
      });
  };
}
